import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DiscountRejectionCouponFormGroup } from '../../../model';

@Component({
  selector: 'discount-rejection-coupon-settings',
  templateUrl: './discount-rejection-coupon-settings.component.html',
  styleUrls: ['./discount-rejection-coupon-settings.component.scss'],
  standalone: false,
})
export class DiscountRejectionCouponSettingsComponent {
  @Input() formGroup: FormGroup<DiscountRejectionCouponFormGroup>;
}
